var _defs, _polygon, _g, _g2, _path, _path2, _path3, _g3, _path4, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _polygon2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParkingCarReducedafter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    viewBox: "0 0 1258 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .parkingCarReduced_after_svg__cls-11,.parkingCarReduced_after_svg__cls-12,.parkingCarReduced_after_svg__cls-15,.parkingCarReduced_after_svg__cls-34,.parkingCarReduced_after_svg__cls-35,.parkingCarReduced_after_svg__cls-37,.parkingCarReduced_after_svg__cls-7,.parkingCarReduced_after_svg__cls-9{stroke:#343a50}.parkingCarReduced_after_svg__cls-11,.parkingCarReduced_after_svg__cls-12,.parkingCarReduced_after_svg__cls-15,.parkingCarReduced_after_svg__cls-35,.parkingCarReduced_after_svg__cls-37,.parkingCarReduced_after_svg__cls-9{stroke-miterlimit:10}.parkingCarReduced_after_svg__cls-3{fill:#eb9a6b}.parkingCarReduced_after_svg__cls-4{fill:#343a50}.parkingCarReduced_after_svg__cls-5{fill:#d38259}.parkingCarReduced_after_svg__cls-20,.parkingCarReduced_after_svg__cls-22,.parkingCarReduced_after_svg__cls-7{fill:#dedede}.parkingCarReduced_after_svg__cls-34,.parkingCarReduced_after_svg__cls-7{stroke-linecap:round;stroke-linejoin:round}.parkingCarReduced_after_svg__cls-11,.parkingCarReduced_after_svg__cls-12,.parkingCarReduced_after_svg__cls-34,.parkingCarReduced_after_svg__cls-35,.parkingCarReduced_after_svg__cls-37,.parkingCarReduced_after_svg__cls-7,.parkingCarReduced_after_svg__cls-9{stroke-width:2px}.parkingCarReduced_after_svg__cls-9{fill:#7fc3ca}.parkingCarReduced_after_svg__cls-11{fill:#d3ac8c}.parkingCarReduced_after_svg__cls-12{fill:#eec6a2}.parkingCarReduced_after_svg__cls-17{fill:#e4e4e4}.parkingCarReduced_after_svg__cls-16,.parkingCarReduced_after_svg__cls-22{mix-blend-mode:multiply}.parkingCarReduced_after_svg__cls-15{fill:#248f76;stroke-width:3px}.parkingCarReduced_after_svg__cls-19{fill:#89bb21}.parkingCarReduced_after_svg__cls-34,.parkingCarReduced_after_svg__cls-35{fill:#ed2867}.parkingCarReduced_after_svg__cls-37{fill:#fff}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Weniger_Parkpl\\xE4tze_Nachher",
    "data-name": "Weniger Parkpl\\xE4tze_Nachher"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "parkingCarReduced_after_svg__Wiese",
    fill: "#a9bf5c",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    points: "1258.63 480.42 -1.01 480.42 -.94 701.74 1259.08 701.74 1258.63 480.42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Haus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Wand"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1260,
    height: 440.33,
    x: -0.98,
    y: -1,
    className: "parkingCarReduced_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 0v438.33H0V0h1258m2-2H-2v442.33h1262V-2z",
    className: "parkingCarReduced_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Linke_Wand"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 358.8,
    height: 440.33,
    x: -0.98,
    y: -1,
    className: "parkingCarReduced_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83 0v438.33H0V0h356.83m2-2H-2v442.33h360.83V-2z",
    className: "parkingCarReduced_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__T\\xFCr"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 331.22,
    height: 383.33,
    x: 464.33,
    y: 56,
    fill: "#bc7353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.55 57v381.33H465.33V57h329.22m2-2H463.33v385.33h333.22V55z",
    className: "parkingCarReduced_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 265.48,
    height: 360.17,
    x: 494.97,
    y: 79.16,
    className: "parkingCarReduced_after_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.45 80.16v358.17H496V80.16h263.45m2-2H494v362.17h267.45V78.16z",
    className: "parkingCarReduced_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 465.33,
    x2: 495.97,
    y1: 57,
    y2: 80.16,
    className: "parkingCarReduced_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 794.55,
    x2: 759.45,
    y1: 57,
    y2: 80.16,
    className: "parkingCarReduced_after_svg__cls-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__T\\xFCr-2",
    "data-name": "T\\xFCr"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "parkingCarReduced_after_svg__T\\xFCr-3",
    width: 165.18,
    height: 336.88,
    x: 547.33,
    y: 102.72,
    fill: "#a98969",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-name": "T\\xFCr"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "parkingCarReduced_after_svg__Fenster4",
    width: 99.73,
    height: 63.23,
    x: 580.05,
    y: 136.54,
    className: "parkingCarReduced_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "parkingCarReduced_after_svg__Fenster3",
    width: 99.73,
    height: 63.23,
    x: 580.05,
    y: 207.25,
    className: "parkingCarReduced_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "parkingCarReduced_after_svg__Fenster2",
    width: 99.73,
    height: 63.23,
    x: 580.05,
    y: 276.88,
    className: "parkingCarReduced_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "parkingCarReduced_after_svg__Fenster1",
    width: 99.73,
    height: 63.23,
    x: 580.05,
    y: 346.58,
    className: "parkingCarReduced_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "parkingCarReduced_after_svg__T\\xFCrknauf",
    cx: 679.78,
    cy: 273.81,
    r: 9.57,
    fill: "#fcbe42",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    width: 200.51,
    height: 328.88,
    x: 30.96,
    y: 35.38,
    className: "parkingCarReduced_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Fesnter-rechts2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.51,
    height: 328.88,
    x: 1042.99,
    y: 54.78,
    className: "parkingCarReduced_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1129.94 383.13 1129.94 232.47 1042.86 232.47 1042.86 205.86 1129.94 205.86 1129.94 55.21 1156.56 55.21 1156.56 205.86 1243.59 205.86 1243.59 232.47 1156.56 232.47 1156.56 383.13 1129.94 383.13",
    className: "parkingCarReduced_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.55 56.21v150.65h87v24.62h-87v150.65h-24.61V231.48h-87.08v-24.62h87.08V56.21h24.61m2-2h-28.61v150.65h-87.08v28.62h87.08v150.65h28.61V233.48h87v-28.62h-87V54.21z",
    className: "parkingCarReduced_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Fesnter-rechts1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.51,
    height: 328.88,
    x: 825.01,
    y: 54.83,
    className: "parkingCarReduced_after_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.88 363.78 117.88 213.13 30.81 213.13 30.81 186.51 117.88 186.51 117.88 35.86 144.5 35.86 144.5 186.51 231.53 186.51 231.53 213.13 144.5 213.13 144.5 363.78 117.88 363.78",
    className: "parkingCarReduced_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5 36.86v150.65h87v24.62h-87v150.65h-24.62V212.13H31.81v-24.62h87.07V36.86h24.62m2-2h-28.62v150.65H29.81v28.62h87.07v150.65h28.62V214.13h87v-28.62h-87V34.86z",
    className: "parkingCarReduced_after_svg__cls-4"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "911.95 383.13 911.95 232.47 824.88 232.47 824.88 205.86 911.95 205.86 911.95 55.21 938.57 55.21 938.57 205.86 1025.6 205.86 1025.6 232.47 938.57 232.47 938.57 383.13 911.95 383.13",
    className: "parkingCarReduced_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.57 56.21v150.65h87v24.62h-87v150.65H913V231.48h-87.12v-24.62H913V56.21h24.62m2-2H911v150.65h-87.12v28.62H911v150.65h28.62V233.48h87v-28.62h-87V54.21z",
    className: "parkingCarReduced_after_svg__cls-4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__B\\xFCrgersteig_hinten"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1.01 481.65 1260.53 481.65 1260.53 438.52 -.98 438.52 -1.01 481.65",
    className: "parkingCarReduced_after_svg__cls-11"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1261.75,
    height: 23.13,
    x: -1.01,
    y: 458.53,
    className: "parkingCarReduced_after_svg__cls-12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Pflanze"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M861.79 473.26c-.38 8.47-13.52 14.74-29.35 14s-28.34-8.18-28-16.65 13.53-14.76 29.35-14 28.38 8.17 28 16.65z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#e4e4e4"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#248f76",
    d: "M852.6 465.71c-.38 8.47-13.52 14.75-29.35 14s-28.34-8.19-28-16.66 13.52-14.76 29.35-14 28.4 8.19 28 16.66z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M852 477.58zM918.25 408.2c-.58-.17-1.16-.36-1.75-.5l-1.77-.38-1.79-.37c-.6-.12-1.21-.27-1.81-.33l-3.68-.46a69 69 0 00-15.11.29 85.45 85.45 0 00-15.1 3.54 107.73 107.73 0 00-14.42 6.22l-.56.31a71.6 71.6 0 016.66-8.19 61.21 61.21 0 0110.34-8.59l3-1.81c.49-.32 1-.55 1.52-.82l1.56-.79 1.58-.79c.53-.25 1.08-.45 1.62-.68l3.31-1.33h-5.4l-1.81.16-1.82.16c-.61.06-1.23.1-1.83.22l-3.65.63a69.64 69.64 0 00-14.37 4.72 84.77 84.77 0 00-13.43 7.82 108.2 108.2 0 00-12 10.18c-.3.29-.59.61-.89.91 1.31-3.84 2.77-7.62 4.44-11.31 4.22-9.35 9.7-18.18 17.06-25.48A59.15 59.15 0 01885.47 366a61.92 61.92 0 00-16.5 2.19 66.65 66.65 0 00-15.82 6.71c-10.07 5.87-18.75 14.14-26.09 23.29a150.68 150.68 0 00-11.73 17l-.18-.22c-2.55-3.15-5.2-6.18-8-9-.69-.72-1.42-1.41-2.13-2.1s-1.42-1.38-2.16-2l-2.2-2-2.26-1.87c-.74-.63-1.52-1.23-2.29-1.82s-1.54-1.18-2.32-1.75c-1.6-1.1-3.14-2.23-4.78-3.23a96.15 96.15 0 00-9.86-5.51 95.84 95.84 0 016.05 9.25c.93 1.55 1.73 3.19 2.56 4.77.4.8.77 1.62 1.15 2.43s.75 1.61 1.08 2.44l1 2.44.92 2.48c.32.82.59 1.65.86 2.48s.56 1.65.8 2.49c.7 2.33 1.3 4.68 1.83 7-1.61-.81-3.23-1.6-4.87-2.34-3.69-1.65-7.41-3.13-11.19-4.39-.93-.33-1.9-.6-2.84-.9s-1.88-.58-2.84-.83l-2.85-.75-2.86-.65c-.94-.22-1.9-.4-2.86-.57s-1.9-.36-2.86-.5c-1.92-.26-3.79-.56-5.71-.7a94.87 94.87 0 00-11.26-.41 91.66 91.66 0 019.54 5.48c1.53.95 3 2.05 4.43 3.08.72.53 1.42 1.1 2.12 1.64s1.39 1.09 2.06 1.68l2 1.72 1.93 1.79c.65.58 1.27 1.2 1.88 1.82s1.24 1.22 1.83 1.85c2.4 2.51 4.62 5.14 6.72 7.82a110.74 110.74 0 017.68 11.34l-.87-.1a59.16 59.16 0 00-19.07 1.85 107.48 107.48 0 00-17.35 6.16 104.21 104.21 0 0117.89-2 52.8 52.8 0 0117 2.2 31.79 31.79 0 017.17 3.4c.58.38 1.14.79 1.68 1.21.25.6.51 1.2.75 1.8.6 1.48 1.14 3 1.63 4.42.24.72.46 1.44.65 2.13.1.35.19.68.26 1s0 .29.08.44a.62.62 0 010 .13l3.15-1.87a16.79 16.79 0 01.77 1.8 23.63 23.63 0 011 3.31c.11.56.21 1.11.27 1.64a6.84 6.84 0 01.06.76 1.9 1.9 0 010 .33v.08L816.6 474l28.21 5.38v-1.08-1.45c0-.83 0-1.69.07-2.54l.12-.42 7 3.7v-.39l.18-.65c.13-.46.26-.92.41-1.4.3-.95.64-1.92 1-2.89.7-2 1.45-3.93 2.27-5.89q1.59-3.85 3.44-7.64c.76-.32 1.53-.62 2.32-.89a53.11 53.11 0 0117-2.2 103.25 103.25 0 0117.89 2 106.79 106.79 0 00-17.34-6.17 60.74 60.74 0 00-14.93-2 109.52 109.52 0 0111.44-16.19 89.71 89.71 0 019.13-9.16 73.26 73.26 0 0110.72-7.48 61.47 61.47 0 0112.38-5.18l3.34-.86a14 14 0 011.69-.34l1.72-.3 1.74-.29c.58-.09 1.16-.12 1.75-.18l3.55-.3zM844.86 479.36h-.05z",
    className: "parkingCarReduced_after_svg__cls-15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M795.25 470.38v-.12l-.09.05zM800.52 476.39v-.09z",
    className: "parkingCarReduced_after_svg__cls-15"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "parkingCarReduced_after_svg__cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M784.76 420.21c1.63.74 3.26 1.52 4.87 2.33-.26-1.15-.55-2.3-.85-3.45a112 112 0 00-20-6.41 94.92 94.92 0 00-22.7-2.17l.15.07a97.84 97.84 0 0115.95 2.1 113.84 113.84 0 0122.58 7.53zM878.81 451.47c-4.77-1.18-10.34-.23-15.5-.24 3.34-5.7 7.69-12.9 12-17.92a74.27 74.27 0 0119.86-16.64 58.44 58.44 0 0126.17-7.44 61.85 61.85 0 00-14.23-3.09 63.24 63.24 0 00-9.55-.21c1 .05 2 .11 2.94.21a61.74 61.74 0 0114.23 3.09 58.44 58.44 0 00-26.16 7.44 74.11 74.11 0 00-19.86 16.64c-4.31 5-8.67 12.22-12 17.92 5.17 0 10.73-.94 15.51.24a98.41 98.41 0 0113.7 4.61c3.41.36 6.84.9 10.24 1.57a103.42 103.42 0 00-17.35-6.18zM759.13 453.53c-2.55 0-5.1.21-7.65.48-1.22.52-2.44 1-3.64 1.57a107 107 0 0115.7-2c-1.46-.05-2.94-.07-4.41-.05zM854.68 457.81c-.79.26-1.56.55-2.31.86-1.23 2.53-2.39 5.09-3.46 7.67-.81 2-1.58 3.93-2.27 5.89-.34 1-.67 1.95-1 2.89-.15.48-.3.95-.42 1.4l-.17.65a2.06 2.06 0 00-.08.49l-.2-.1c-2.73 5.75-11.65 9.93-22.73 10.64l.84.05c13.66.62 25.31-4 28.49-10.69l.21.1a1.54 1.54 0 01.07-.49l.18-.65c.12-.45.26-.92.41-1.4.31-.94.64-1.91 1-2.89.7-2 1.47-3.93 2.28-5.89 1.06-2.58 2.22-5.14 3.45-7.67.76-.31 1.53-.6 2.31-.86a48.08 48.08 0 0112.57-2.15l-2.19-.07a52.52 52.52 0 00-16.98 2.22zM851.13 381.56c-7.36 7.31-12.83 16.15-17.06 25.5-1.65 3.69-8.82 21.44-10.13 25.27.29-.3 4.38-4.38 4.68-4.68 2.88-2.83 2.13-1.73 5.32-4.21.33-.8 6.38-15.58 6.74-16.38 4.22-9.35 9.69-18.19 17.05-25.5a60.08 60.08 0 0112.44-9.56 58.68 58.68 0 0115-6 60.73 60.73 0 00-8.7.57 58.51 58.51 0 00-12.91 5.43 60.28 60.28 0 00-12.43 9.56zM846.89 426l5.06-2.58c3.14-1.64 1.87-.87 5.15-2.17 1-1.18 10.39-11.84 11.46-13a58.91 58.91 0 0122.89-14.79 61.09 61.09 0 00-7 .16A58.88 58.88 0 00862 408.31c-2.51 2.57-13.12 14.83-15.11 17.69zM808.21 415c0 .07 5.1 7.61 5.16 7.68.91-1.52 2-4.68 3-6.17-4.08-4.64-13.65-14.73-18.3-18.53a95.73 95.73 0 00-19.26-12.3c1.49 2 2.87 4 4.16 6.08a99.73 99.73 0 018.5 6.22A114.37 114.37 0 01808.21 415z",
    className: "parkingCarReduced_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 788.33,
    x2: 788.29,
    y1: 470.39,
    y2: 470.41,
    className: "parkingCarReduced_after_svg__cls-17"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "parkingCarReduced_after_svg__Topf",
    fill: "#c66852",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M848.38 545.87h-42.51a12.12 12.12 0 01-13.37-9.42l-11.91-62.9c-1.24-6.13 5.46-15.69 14.72-13.86 23.83 4.7 40.51 2.21 63.62 0 9.41-.9 16 7.72 14.72 13.86q-6 31.45-11.9 62.9a12.14 12.14 0 01-13.37 9.42z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Busch2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M969.82 575.53h-4.07c-23.69 0-43-12.26-43-27.32 0-12.52 13.23-23.27 31.94-26.4-5.29-4.63-8.16-10.23-8.16-16 0-12.41 12.84-23.06 31.46-26.31a17.62 17.62 0 01-1-5.66c0-13.4 14.81-24.57 35.41-26.87.87-14.58 19.8-26.27 43-26.27a66.31 66.31 0 0111.86 1.05c8-7.6 21.26-12.12 35.71-12.12a61.91 61.91 0 0123.27 4.34c7.37-6.73 19.28-11 32.22-11.61 8-7.77 21.36-12.4 36-12.4 23.3 0 42.33 11.85 43 26.57 14.93 2.26 27 9.55 31.21 18.93h.24c20.88 0 38.33 9.24 42.16 22.14 20.76.2 38 9.52 41.57 22.43 17.26 3.81 28.78 14.1 28.78 25.79 0 6.7-3.7 13-10.49 17.92 14.63 4.57 23.91 14 23.91 24.5 0 12.42-13.19 23.28-32.07 26.41h-.12l-390.72.89c-.64.06-1.31.09-2.08.09z",
    className: "parkingCarReduced_after_svg__cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.48 391.35c22.9 0 41.47 11.56 41.47 25.82v.55c15.64 2 28 9.54 31.76 19.16h1.22c20.9 0 38.14 9.64 41 22.15h.47c20.93 0 38.19 9.66 41 22.2 16.55 3.39 28.51 13.08 28.51 24.52 0 7.25-4.81 13.79-12.54 18.48 15.21 3.83 26 13.1 26 23.94 0 12-13.08 22-30.81 24.93l-390.67.89c-.68.06-1.35.09-2 .09-1.33 0-2.65-.09-4.08-.09-22.9 0-41.47-11.56-41.47-25.82 0-12.7 14.73-23.23 34.13-25.39-6.42-4.55-10.35-10.5-10.35-17 0-12.23 13.68-22.45 32-25.12a17 17 0 01-1.52-6.85c0-13 15.39-23.68 35.4-25.51v-.31c0-14.26 18.57-25.82 41.48-25.82a64.7 64.7 0 0112.35 1.17c7.32-7.34 20.34-12.24 35.22-12.24a60 60 0 0123.59 4.6c7-6.79 18.85-11.4 32.55-11.9 7.29-7.41 20.38-12.37 35.36-12.37m0-3c-14.78 0-28.36 4.63-36.64 12.43-12.66.67-24.34 4.84-31.89 11.34a64.08 64.08 0 00-23-4.1c-14.49 0-27.87 4.47-36.18 12a69.11 69.11 0 00-11.39-.94c-11.64 0-22.61 2.85-30.92 8-7.86 4.89-12.55 11.36-13.41 18.41-20.74 2.69-35.53 14.3-35.53 28.21a18.72 18.72 0 00.56 4.49c-18.46 3.72-31.06 14.7-31.06 27.48 0 5.39 2.28 10.6 6.53 15.09-17.9 3.85-30.31 14.73-30.31 27.33 0 8 4.81 15.36 13.56 20.8 8.3 5.17 19.28 8 30.91 8H969.84c.68 0 1.49 0 2.16-.09l390.53-.89h.49c19.62-3.25 33.32-14.72 33.32-27.89 0-10.55-8.58-20-22.32-25 5.78-5 8.9-11 8.9-17.39 0-12.22-11.62-22.94-29.1-27.06-4.23-12.87-21.18-22.13-41.66-22.64-4.58-12.83-21.88-21.95-42.54-22.15-4.69-9.28-16.13-16.26-30.75-18.73-.76-7.18-5.47-13.78-13.46-18.75-8.3-5.17-19.28-8-30.91-8z",
    className: "parkingCarReduced_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "parkingCarReduced_after_svg__cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M942.74 560.11c0-12.7 14.74-23.24 34.14-25.4-6.42-4.54-10.35-10.49-10.35-17 0-12.23 13.68-22.46 32-25.12a16.83 16.83 0 01-1.52-6.85c0-13 15.38-23.68 35.4-25.51v-.31c0-14.26 18.57-25.82 41.48-25.82a65.72 65.72 0 0112.36 1.16c7.31-7.33 20.33-12.23 35.22-12.23a60 60 0 0123.59 4.6c7-6.79 18.85-11.41 32.54-11.9 7.29-7.41 20.38-12.37 35.36-12.37a62.52 62.52 0 0119.07 2.9c-6.62-8.79-20.92-14.89-37.54-14.89-15 0-28.07 5-35.36 12.37-13.7.49-25.6 5.11-32.55 11.9A60 60 0 001103 411c-14.88 0-27.9 4.9-35.22 12.23a65.56 65.56 0 00-12.36-1.16c-22.9 0-41.47 11.56-41.47 25.82v.31c-20 1.83-35.4 12.54-35.4 25.51a17 17 0 001.52 6.85c-18.34 2.67-32 12.89-32 25.12 0 6.53 3.93 12.48 10.36 17-19.41 2.16-34.15 12.69-34.15 25.39 0 10 9.11 18.62 22.42 22.92a18.13 18.13 0 01-3.96-10.88z",
    className: "parkingCarReduced_after_svg__cls-20"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Busch1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.55 521.67h-4c-22.89 0-41.52-11.85-41.52-26.42 0-12.07 12.74-22.46 30.76-25.5-5-4.55-7.79-9.93-7.79-15.51 0-12 12.38-22.27 30.34-25.43a17.17 17.17 0 01-.91-5.42c0-12.95 14.29-23.74 34.17-26 .88-14.08 19.16-25.36 41.49-25.36a64.39 64.39 0 0111.44 1c7.72-7.33 20.53-11.69 34.47-11.69a59.8 59.8 0 0122.45 4.18c7.11-6.49 18.6-10.63 31.08-11.2 7.69-7.5 20.62-12 34.76-12 22.49 0 40.86 11.43 41.51 25.64 14.38 2.19 26 9.22 30.1 18.26h.2c20.15 0 37 8.91 40.72 21.36 20 .2 36.6 9.19 40.11 21.65 16.66 3.69 27.79 13.63 27.79 24.93 0 6.45-3.55 12.5-10.07 17.28 14.09 4.42 23 13.48 23 23.65 0 12-12.74 22.52-31 25.54h-.11l-377 .86c-.6.16-1.24.18-1.99.18z",
    className: "parkingCarReduced_after_svg__cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.33 343.9c22.1 0 40 11.16 40 24.92v.52c15.09 2 27 9.21 30.65 18.5h1.18c20.16 0 36.8 9.29 39.57 21.37h.45c20.2 0 36.86 9.32 39.59 21.42 16 3.28 27.51 12.62 27.51 23.66 0 7-4.65 13.31-12.11 17.84 14.68 3.69 25.05 12.63 25.05 23.09 0 11.55-12.62 21.23-29.73 24.06l-377 .86c-.66.06-1.3.08-2 .08-1.28 0-2.56-.08-3.94-.08-22.1 0-40-11.16-40-24.92 0-12.25 14.22-22.41 32.94-24.5-6.2-4.39-10-10.13-10-16.43 0-11.8 13.2-21.67 30.9-24.24a16.32 16.32 0 01-1.47-6.61c0-12.51 14.85-22.85 34.17-24.62a2.85 2.85 0 010-.29c0-13.76 17.92-24.92 40-24.92a62.81 62.81 0 0111.93 1.13c7.06-7.08 19.62-11.81 34-11.81a58 58 0 0122.77 4.44c6.71-6.55 18.18-11 31.4-11.48 7-7.15 19.67-11.94 34.12-11.94m0-3c-14.27 0-27.39 4.46-35.4 12-12.19.66-23.45 4.68-30.75 10.93a61.81 61.81 0 00-22.16-4c-14 0-26.9 4.31-34.95 11.58a66.08 66.08 0 00-11-.9c-11.24 0-21.85 2.75-29.88 7.75-7.59 4.73-12.12 11-13 17.77-20 2.62-34.29 13.85-34.29 27.31a17.8 17.8 0 00.52 4.26c-17.81 3.62-29.95 14.24-29.95 26.59 0 5.18 2.17 10.18 6.21 14.5-17.14 3.76-29.07 14.26-29.07 26.43 0 7.73 4.67 14.9 13.14 20.17 8 5 18.64 7.75 29.88 7.75h4c.67 0 1.44 0 2.09-.08l376.84-.86h.48c19-3.14 32.24-14.25 32.24-27 0-10.18-8.23-19.28-21.43-24.18 5.51-4.78 8.49-10.57 8.49-16.75 0-11.83-11.22-22.2-28.11-26.2-4.12-12.42-20.46-21.35-40.2-21.86-4.47-12.37-21.15-21.16-41.07-21.38-4.54-8.94-15.56-15.66-29.64-18.05-.75-6.93-5.31-13.3-13-18.1-8-5-18.65-7.75-29.89-7.75z",
    className: "parkingCarReduced_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "parkingCarReduced_after_svg__cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.42 506.74c0-12.25 14.22-22.42 32.94-24.5-6.2-4.39-10-10.13-10-16.43 0-11.8 13.2-21.67 30.9-24.24a16.32 16.32 0 01-1.46-6.57c0-12.52 14.85-22.85 34.16-24.62v-.29c0-13.77 17.92-24.92 40-24.92a62.72 62.72 0 0111.92 1.12c7.06-7.07 19.63-11.8 34-11.8a57.89 57.89 0 0122.76 4.44c6.71-6.56 18.19-11 31.41-11.48 7-7.15 19.66-11.94 34.12-11.94a60.06 60.06 0 0118.39 2.8c-6.38-8.48-20.18-14.37-36.22-14.37-14.45 0-27.08 4.79-34.12 11.94-13.21.47-24.7 4.93-31.41 11.48a57.89 57.89 0 00-22.81-4.48c-14.36 0-26.92 4.73-34 11.81a62.81 62.81 0 00-11.93-1.13c-22.1 0-40 11.16-40 24.92v.29c-19.25 1.77-34.07 12.11-34.07 24.62a16.32 16.32 0 001.47 6.61c-17.7 2.57-30.89 12.44-30.89 24.24 0 6.3 3.78 12 10 16.43-18.72 2.09-32.94 12.25-32.94 24.5 0 9.63 8.79 18 21.63 22.12a17.49 17.49 0 01-3.85-10.55z",
    className: "parkingCarReduced_after_svg__cls-20"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Baum"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.59,
    cy: 38.14,
    fill: "#89bb21",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    rx: 174.94,
    ry: 176.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-94.08 41.51c0-97.38 78.32-176.32 174.94-176.32 4 0 8 .15 11.9.42a173.86 173.86 0 00-36.17-3.79c-96.62 0-174.94 78.94-174.94 176.32 0 93.35 72 169.74 163 175.91-79.22-16.8-138.73-87.66-138.73-172.54z",
    className: "parkingCarReduced_after_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b472d",
    d: "M33.26 554.17a8.43 8.43 0 01-6.08-2.6 8 8 0 01-2.24-6l27.92-410.13-31.73-32a2.51 2.51 0 01-.55-2.77A2.54 2.54 0 0122.92 99a2.62 2.62 0 011.08.3l30.28 14.77 4.19-61.55.25-4.87a8 8 0 0115.95-.3l2.82 38.72 30-16h.24a5.1 5.1 0 01.87-.07 4.64 4.64 0 014.42 3.23 4.69 4.69 0 01-1.61 5.3l-31.2 22.7 28.06 444.06a8.18 8.18 0 01-2.12 6.17 8.43 8.43 0 01-6.19 2.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.76 41.51a6.29 6.29 0 016.46 6l3 41 31.86-17a3.2 3.2 0 01.61 0 3.26 3.26 0 011.9 5.84L78.66 100.5l28.11 444.88a6.76 6.76 0 01-6.81 7.29h-66.7a6.77 6.77 0 01-6.83-7l28-410.76-32.24-32.57a1.06 1.06 0 01.73-1.8 1 1 0 01.46.11l32.28 15.75L60 52.62l.26-4.9a6.3 6.3 0 016.5-6.21m0-3a9.32 9.32 0 00-9.5 9.06l-.26 4.9-4 59.28L24.7 98a4 4 0 00-4.64 6.49L51.32 136 23.44 545.42v.06a9.54 9.54 0 002.65 7.12 9.93 9.93 0 007.17 3.07H100a9.94 9.94 0 007.3-3.2 9.67 9.67 0 002.5-7.31L81.76 102l30.57-22.3a6.26 6.26 0 00-3.72-11.22 6.27 6.27 0 00-1.14.1l-.46.08-.42.22-27.73 14.78-2.65-36.39a9.26 9.26 0 00-9.45-8.76z",
    className: "parkingCarReduced_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "parkingCarReduced_after_svg__cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.45 91.86l35-18.67a3.13 3.13 0 00-3.41-1.7l-31.86 17zM62.06 119.51l4.54-66.89.25-4.9a6.22 6.22 0 013.2-5.37c-3.75-2.09-9.5-.25-9.79 5.37l-.26 4.9-4.32 63.78zM33 545.63l28-410.76-30.39-30.69-7.23-3.53a1 1 0 00-1.19 1.69l32.21 32.53-28 410.76a6.77 6.77 0 006.83 7h6.6a6.76 6.76 0 01-6.83-7z",
    className: "parkingCarReduced_after_svg__cls-20"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Schild"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M1063.54 665.05h-.93c-3.46 0-6.26-1.65-6.26-3.68v-417c0-2 2.8-3.68 6.26-3.68h.93c3.46 0 6.26 1.65 6.26 3.68v417c0 2.03-2.8 3.68-6.26 3.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bf786a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M895.59 296.45l-.82 40.79a18.17 18.17 0 0018.38 18.32h276.39a18.66 18.66 0 0012-4.4l23.46-19.9a17.69 17.69 0 00-.5-27.54l-26.5-20.9a18.72 18.72 0 00-11.55-4H914a18.19 18.19 0 00-18.41 17.63z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#343a50",
    fontFamily: "Lato-Regular,Lato",
    fontSize: 34,
    transform: "translate(936.62 328.66)"
  }, /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: "-.03em"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.2,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.59,
    y: 0,
    letterSpacing: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.85,
    y: 0,
    letterSpacing: ".02em"
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 61.37,
    y: 0,
    letterSpacing: 0
  }, "pl"), /*#__PURE__*/React.createElement("tspan", {
    x: 88.74,
    y: 0,
    letterSpacing: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 104.99,
    y: 0
  }, "tz in 300m")))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Bank"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.18,
    d: "M-43.89 525.26h439.57L386 513.13c-7.76-8.67-35.19-27.05-46-27L6.39 487.46C-2.36 487.5-26.06 505-32.29 512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M-25.23 566.07v62.12a15.73 15.73 0 01-3.38 9.81h-24.46a15.73 15.73 0 01-3.38-9.76v-62.17c0-39.85 32.17-72.28 71.71-72.28h321.26c39.54 0 71.72 32.43 71.72 72.28v62.12a15.74 15.74 0 01-2.46 8.45h-26.31a15.82 15.82 0 01-2.45-8.45v-62.12a40.7 40.7 0 00-40.5-40.81H15.26a40.7 40.7 0 00-40.49 40.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.67 481.47h95.86a5.27 5.27 0 014.61 2.71l3 6.48-111-.66 2.69-5.29a5.28 5.28 0 014.84-3.24zM7.87 481.47h95.86a5.27 5.27 0 014.6 2.71l3 6.48L.31 490 3 484.71a5.27 5.27 0 014.87-3.24zM249.54 481.47h95.86a5.27 5.27 0 014.61 2.71l3 6.48L242 490l2.69-5.29a5.28 5.28 0 014.85-3.24z",
    className: "parkingCarReduced_after_svg__cls-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.25 501.48h100.34a5.75 5.75 0 005.72-5.76v-3.49a5.75 5.75 0 00-5.72-5.76H247.25a5.75 5.75 0 00-5.71 5.76v3.49a5.75 5.75 0 005.71 5.76zM126.45 501.48h100.34a5.75 5.75 0 005.71-5.76v-3.49a5.75 5.75 0 00-5.71-5.76H126.45a5.75 5.75 0 00-5.71 5.76v3.49a5.75 5.75 0 005.71 5.76zM5.64 501.48H106a5.76 5.76 0 005.72-5.76v-3.49a5.76 5.76 0 00-5.72-5.76H5.64a5.75 5.75 0 00-5.71 5.76v3.49a5.75 5.75 0 005.71 5.76z",
    className: "parkingCarReduced_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37 488.08c-.7 1.14-2.24 1-2.24 2.4a7.5 7.5 0 007.45 7.5l95.75-.68c.39 0 1-.48 1.38-.54a3.84 3.84 0 01-3.56 2.83H6.09c-4.1 0-4.31-2.8-4.31-6.93 0-3.74 2.03-4.02 5.59-4.58zM128.24 488c-.69 1.14-2.23 1-2.23 2.39a7.5 7.5 0 007.44 7.51l95.76-.68c.38 0 1-.48 1.38-.54a3.86 3.86 0 01-3.57 2.83H127c-4.1 0-4.31-2.8-4.31-6.93-.04-3.7 1.99-3.98 5.55-4.58zM249.05 488.22c-.7 1.14-2.24 1-2.24 2.39a7.5 7.5 0 007.45 7.51l95.75-.68c.39 0 1-.48 1.38-.54a3.84 3.84 0 01-3.56 2.83H247.77c-4.1 0-4.31-2.8-4.31-6.93 0-3.74 2.03-4.03 5.59-4.58z",
    className: "parkingCarReduced_after_svg__cls-22"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__B\\xFCrgersteig_vorne"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1260.02,
    height: 43.13,
    x: -0.94,
    y: 701.74,
    className: "parkingCarReduced_after_svg__cls-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1259.08 721.74 -.98 721.74 -.94 744.87 1259.08 744.87 1259.08 721.74",
    className: "parkingCarReduced_after_svg__cls-12"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Stra\\xDFe"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1261,
    height: 338.13,
    x: -1.5,
    y: 743.37,
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 744.87V1080H0V744.87h1258m3-3H-3V1083h1264V741.87z",
    className: "parkingCarReduced_after_svg__cls-4"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "parkingCarReduced_after_svg__Stra\\xDFenmarkierung"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198.53,
    height: 23.62,
    x: -0.94,
    y: 900.63,
    className: "parkingCarReduced_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.88,
    height: 23.62,
    x: 398.3,
    y: 900.63,
    className: "parkingCarReduced_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.88,
    height: 23.62,
    x: 799.47,
    y: 900.63,
    className: "parkingCarReduced_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57.83,
    height: 23.62,
    x: 1201.23,
    y: 900.63,
    className: "parkingCarReduced_after_svg__cls-37"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "parkingCarReduced_after_svg__Weg",
    points: "496.62 701.74 521.86 481.24 729.43 481.24 754.85 701.74 496.62 701.74",
    className: "parkingCarReduced_after_svg__cls-12"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingCarReducedafter);
export default __webpack_public_path__ + "static/media/parkingCarReduced.after.1690a354.svg";
export { ForwardRef as ReactComponent };